/**
 * Static content for the wedding website.
 *
 * Update names, dates, venue details, timeline chapters, and
 * dress-code copy here without touching component files.
 */

/** The couple. */
export const COUPLE = {
  bride:        'Sylvie',
  groom:        'Marko',
  displayNames: 'Sylvie & Marko',
};

/** Ceremony-specific details keyed by venue slug. */
export const CEREMONY = {
  toronto: {
    slug:         'toronto',
    label:        'Toronto',
    flag:         '🍁',
    tagline:      'Canada Ceremony',
    accentColour: '#c85a28',
    borderColour: '#8a3a18',
    details: [
      ['Venue',   'Condo Lakefront'],
      ['City',    'Toronto, Canada'],
      ['Date',    'TBD · 2026'],
      ['Arrival', 'By boat 🍁'],
      ['Attire',  'Cocktail Garden'],
      ['Season',  'Peak Autumn'],
    ],
    cards: [
      { icon: '🏙', title: 'CITY VENUE',    lines: ['Condo lakefront', 'Toronto skyline', 'Maple leaf season'] },
      { icon: '⛵', title: 'BOAT ARRIVAL',  lines: ['Board from the', 'lakeside dock', 'Scenic voyage in!'] },
      { icon: '🍁', title: 'AUTUMN VIBE',   lines: ['Cocktail garden', 'Falling maple leaves', 'Warm golden tones'] },
      { icon: '📅', title: 'DATE',          lines: ['TBD · 2026', 'Toronto, Canada', 'Details coming!'] },
    ],
  },
  japan: {
    slug:         'japan',
    label:        'Osaka',
    flag:         '⛩',
    tagline:      'Japan Ceremony',
    accentColour: '#b85c38',
    borderColour: '#8a5a18',
    details: [
      ['Ryokan',   'Nanten-en Inn'],
      ['Location', 'Tennoji, Osaka'],
      ['Date',     '31 October 2026'],
      ['Style',    'Meiji-era Garden'],
      ['Attire',   'Cocktail Garden'],
      ['Season',   'Peak Autumn 🍁'],
      ['Weather',  '~15–20°C evening'],
    ],
    cards: [
      { icon: '⛩', title: 'NANTEN-EN',    lines: ['Tennoji, Osaka', 'Meiji-era ryokan', 'Garden ceremony'] },
      { icon: '🍁', title: 'PEAK AUTUMN',  lines: ['Koyo foliage', 'October magic', 'Maple canopy'] },
      { icon: '👘', title: 'ATTIRE',       lines: ['Cocktail garden', 'Burgundy · Sage', 'Warm autumn tones'] },
      { icon: '📅', title: 'DATE',         lines: ['31 Oct 2026', 'Osaka, Japan', '31.10.26'] },
    ],
  },
};

/** Relationship timeline chapters, in chronological order. */
export const TIMELINE = [
  { gem: '🌱', level: 'CHAPTER I',              title: 'First Meeting',      desc: 'Two strangers. One city. Autumn leaves falling.',          gold: false },
  { gem: '🌸', level: 'CHAPTER II · 2020',      title: 'Together',           desc: 'Hearts merged. Co-op mode: ON.',                           gold: false },
  { gem: '🏠', level: 'CHAPTER III · 2022',     title: 'Home · Toronto',     desc: 'A little house. A life taking root.',                      gold: false },
  { gem: '🐾', level: 'CHAPTER IV · 2023',      title: 'Matcha Arrives',     desc: 'Golden pup joined the party. +999 joy.',                   gold: false },
  { gem: '💍', level: 'CHAPTER V · 2025',       title: 'The Proposal',       desc: 'A ring. A yes. Written in falling leaves.',                gold: false },
  { gem: '⛩',  level: 'CHAPTER VI · 31.10.26', title: 'Forever · Nanten-en',desc: 'Osaka, Japan. Where the story blossoms.',                  gold: true  },
];

/** Bottom navigation items keyed by site slug. */
export const NAV_ITEMS = {
  toronto: [
    { k: 'home',    ic: '🍁', lb: 'HOME'    },
    { k: 'story',   ic: '📖', lb: 'STORY'   },
    { k: 'details', ic: '🏙', lb: 'DETAILS' },
    { k: 'rsvp',    ic: '✉',  lb: 'RSVP'    },
    { k: 'dock',    ic: '⛵', lb: 'DOCK'    },
  ],
  japan: [
    { k: 'home',    ic: '⛩', lb: 'HOME'    },
    { k: 'story',   ic: '📖', lb: 'STORY'   },
    { k: 'details', ic: '🏯', lb: 'DETAILS' },
    { k: 'rsvp',    ic: '✉',  lb: 'RSVP'    },
    { k: 'dock',    ic: '⛵', lb: 'DOCK'    },
  ],
};

/** Dress-code colour palette hex values for reference. */
export const DRESS_CODE_PALETTE = ['#7a2840', '#6b8f5e', '#b85c28', '#c9843c', '#2a5a28'];
